import { render, staticRenderFns } from "./PayPal.vue?vue&type=template&id=1c54106c&scoped=true&"
import script from "./PayPal.vue?vue&type=script&lang=js&"
export * from "./PayPal.vue?vue&type=script&lang=js&"
import style0 from "./PayPal.vue?vue&type=style&index=0&id=1c54106c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c54106c",
  null
  
)

export default component.exports